module.exports = __webpack_public_path__ + "static/img/solutionPic.43b1cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic.jpg
// module id = Mmj2
// module chunks = 0